<template>
  <a-modal v-model="modal" title="新建" width="560px" :maskClosable="false" :closable="false">
    <div class="create-material" v-if="modal">
      <a-form-model :model="formData" ref="form">
        <a-form-model-item
          label="组织"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="organizationCode"
          :rules="rules.organizationCode"
        >
          <global-select
            v-model="formData.organizationCode"
            v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
            selectType="selectAssemble"
            :selectData="inventOrg"
            :disabled="isDisableOrganization"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :assembleLabel="true"
            @change="inventOrgValueOnChange"
          />
        </a-form-model-item>
        <a-form-model-item
          label="车间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="workshopCode"
          :rules="rules.workshopCode"
        >
          <global-select
            :value.sync="formData.workshopCode"
            :selectData="workshopList"
            selectType="selectAssembleFilter"
            :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="班组"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="teamCode"
          :rules="rules.teamCode"
        >
          <global-select
            searchParam="teamCode"
            selectType="selectAssembleSearch"
            :value.sync="formData.teamCode"
            requestApi="/bom/team/list"
            :selectItem="{ value: 'teamCode', label: 'teamName' }"
            :setParams="{ 'workshopCode': formData.workshopCode }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="工作中心"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="centerCode"
          :rules="rules.centerCode"
        >
          <global-select
            searchParam="centerCode"
            selectType="selectAssembleSearch"
            :value.sync="formData.centerCode"
            requestApi="/bom/workCenter/list"
            :selectItem="{ value: 'centerCode', label: 'centerName' }"
            :setParams="{ 'workshopCode': formData.workshopCode }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="开始时间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="startTime"
          :rules="rules.startTime"
        >
          <a-date-picker
            style="width: 100%"
            v-model="formData.startTime"
            :show-time="{
              defaultValue: moment('00:00:00', 'HH:mm:ss')
            }"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </a-form-model-item>
        <a-form-model-item
          label="结束时间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="endTime"
          :rules="rules.endTime"
        >
          <a-date-picker
            style="width: 100%"
            v-model="formData.endTime"
            :show-time="{
              defaultValue: moment('23:59:59', 'HH:mm:ss')
            }"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </a-form-model-item>
        <a-form-model-item
          label="出勤模式"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="modeCode"
          :rules="rules.modeCode"
        >
          <global-select
            searchParam="modeCode"
            selectType="selectSearch"
            :value.sync="formData.modeCode"
            requestApi="/bom/attendanceMode/list"
            :selectItem="{ value: 'modeCode', label: 'modeName' }"
            :setParams="{ 'organizationCode': formData.organizationCode }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="是否生效"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="enable"
        >
          <a-select v-model="formData.enable" disabled placeholder="请选择">
            <a-select-option value="1">是</a-select-option>
            <a-select-option value="0">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="备注"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="remark"
        >
          <a-input v-model="formData.remark" placeholder="请输入" :maxLength="100" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment';

import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'
import { apiTeamScheduleUpdate } from '@/api/mes/productionPrepare/teamSchedule'

export default {
  name: 'CreateModal',
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  created() {
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
  },
  data() {
    return {
      modal: false,
      formData: {
        organizationCode: '', //  组织
        workshopCode: '', // 车间
        centerCode: '', // 工作中心
        modeCode: '', // 出勤模式
        teamCode: '', // 班组编码
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        enable: '1', // 是否生效 0-否 1-是
        remark: '' // 备注
      },
      loading: false,
      rules: {
        organizationCode: [{ required: true, message: ' ', trigger: 'change' }],
        workshopCode: [{ required: true, message: ' ', trigger: 'change' }],
        centerCode: [{ required: true, message: ' ', trigger: 'change' }],
        enable: [{ required: true, message: ' ', trigger: 'change' }],
        teamCode: [{ required: true, message: ' ', trigger: 'change' }],
        startTime: [{ required: true, message: ' ', trigger: 'change' }],
        endTime: [{ required: true, message: ' ', trigger: 'change' }]
      },
      workshopList: [], // 车间列表
      teamList: [], // 班组列表
      centerList: [], // 工作中心列表
      modeList: [] // 出勤模式列表
    }
  },
  methods: {
    moment,
    // 初始化
    show () {
      this.$set(this.formData, 'organizationCode', this.organizationCodeOrigin)
      this.$set(this.formData, 'workshopCode', '')
      this.$set(this.formData, 'centerCode', '')
      this.$set(this.formData, 'modeCode', '')
      this.$set(this.formData, 'teamCode', '')
      this.$set(this.formData, 'startTime', '')
      this.$set(this.formData, 'endTime', '')
      this.$set(this.formData, 'enable', '1')
      this.$set(this.formData, 'remark', '')
      this.modal = true
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiTeamScheduleUpdate(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('创建成功')
              this.$emit("refresh")
              this.modal = false
            } else {
              this.$message.error(res?.msg || '创建失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.formData.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
      this.formData.teamCode = '';
      this.formData.centerCode = '';
      this.formData.modeCode = '';
    }
  }
}
</script>

<style lang="less" scoped></style>
